import { render, staticRenderFns } from "./ajax_btn.vue?vue&type=template&id=96b3118c&scoped=true"
import script from "./ajax_btn.vue?vue&type=script&lang=js"
export * from "./ajax_btn.vue?vue&type=script&lang=js"
import style0 from "./ajax_btn.vue?vue&type=style&index=0&id=96b3118c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b3118c",
  null
  
)

export default component.exports